import {useEffect} from 'react';
import type {PageElementInterface, PageElementsMap} from 'app/interfaces/stores/CasinoGamesStoreInterfaces';

export const isActivePageElement = (el: PageElementInterface | undefined): el is PageElementInterface => Boolean(el?.active && el?.content_type);

export const MARKETING_BLOCK_KEY_ATTR = 'data-marketing-block-key';

export const CASINO_GAMES_GRID_ATTR = 'data-casino-games-grid';

export const CASINO_GAMES_IFRAME_ATTR = 'data-casino-games-iframe';

export const CASINO_ATTRS = {
    GRID: {[CASINO_GAMES_GRID_ATTR]: ''},
    IFRAME: {[CASINO_GAMES_IFRAME_ATTR]: ''}
} as const;

export const CONTENT_TYPE = {
    gameOfWeek: 'game_of_week',
    lootboxes: 'lootboxes',
    newRelease: 'new_release',
    promotions: 'promotions',
    randomSlot: 'random_slot',
    recordWin: 'record_win',
    tournament: 'tournament'
} as const;

export const LAYOUT = {
    marketingBlockRows: 2,
    mobileBlockRows: 1,
    mobileRowsBetweenBlocks: 3,
    randomSlotRows: 1,
    recordWinRows: 1,
    rowsBetweenBlocks: 1
} as const;

export const PRIORITY_FIRST_TYPES = new Set<string>([CONTENT_TYPE.promotions, CONTENT_TYPE.tournament]);

export const RANDOM_SLOT_POSITION = 3;

export const RECORD_WIN_POSITION = 5;

export const insertBlockAtOneBasedPosition = <BlockType>(elements: BlockType[], block: BlockType, oneBasedPosition: number): BlockType[] => {
    const idx = Math.min(oneBasedPosition - 1, elements.length);

    return [
        ...elements.slice(0, idx),
        block,
        ...elements.slice(idx)
    ];
};

export const NOT_FOUND_INDEX = -1;

export const CAROUSEL_NEXT = 'next';
export const CAROUSEL_PREV = 'prev';

export const hasPageElementOfType = (
    pageElements: PageElementsMap | undefined,
    contentType: string
): boolean => Object.values(pageElements ?? {}).some(el => isActivePageElement(el) && el.content_type === contentType);

export const useCasinoMarketingEffects = (
    loadLootboxes: (() => void) | null,
    loadPromotions: (() => void) | null
): void => {
    useEffect(() => {
        loadLootboxes?.();
    }, [loadLootboxes]);
    useEffect(() => {
        loadPromotions?.();
    }, [loadPromotions]);
};
